type ErrorHandler = (message: string) => void

let errorHandler: ErrorHandler | null = null

export function registerGlobalErrorHandler(handler: ErrorHandler): void {
  errorHandler = handler
}

export function unregisterGlobalErrorHandler(): void {
  errorHandler = null
}

export function showGlobalError(message: string): void {
  errorHandler?.(message)
}
